module.exports = __webpack_public_path__ + "img/module2_icon2.50586428.png";